import React from 'react';
import { MenuCellProps } from './menu-cell.types';
import More, { MoreMenuItem } from '../../../more';
import useDeactivateDialog from '../../../product/hooks/use-deactivate-dialog';
import useCheckPage from '../../../../hooks/use-check-page';
import { isShowInfoHint } from '../../select-configuration-to-deactivate/unable-to-deactivate/unable-to-deactivate';
import { ItemPropsForList } from '../../../product/product-view.props';
import { DeactivateIcon } from '../../../icons-new/deactivate';

const MenuCell = ({ row, reloadList }: MenuCellProps) => {
  const { isEmployeeConfigurationsPage, isDriverConfigurationPage } = useCheckPage();
  const { openDeactivateDialog } = useDeactivateDialog({
    configuration: row || ({} as ItemPropsForList),
    refreshList: () => reloadList(true)
  });

  return (isEmployeeConfigurationsPage || isDriverConfigurationPage) &&
    !isShowInfoHint(row?.uds_remove_request_date?.value) ? (
    <More>
      <MoreMenuItem
        label='Konfiguration archivieren'
        minWidth={'240px'}
        onClick={openDeactivateDialog}
        img={<DeactivateIcon />}
      />
    </More>
  ) : null;
};

export default MenuCell;
